var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSuperadmin || _vm.isDownloadAccess)?_c('b-button',{staticClass:"d-flex mt-2",attrs:{"disabled":_vm.sendingRequest,"variant":"rounded"}},[_vm._t("default"),(_vm.sendingRequest)?_c('LoaderAnimation'):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }